import React from 'react';

import styles from './Fieldset.scss';

export type FieldsetProps = {
  legend?: string | JSX.Element;
};

export const Fieldset: React.FunctionComponent<FieldsetProps> = ({
  legend,
  children,
}) => {
  return (
    <fieldset className={`${styles.container} jg-space-pbxs`}>
      {legend && (
        <legend className={`${styles.legend} jg-space-mbms jg-space-mbmd@md`}>
          {legend}
        </legend>
      )}
      {children}
    </fieldset>
  );
};
